export const DeviceBreakpoints = {
  MOBILE: 576,
  TABLET: 768,
};
